<template>
    <div class="diolog_style">
        <div class="main_style device_statistic">
            <div class="selfClose_btn" style="top:10px; right: 20px;" @click="close"></div>
            <div class="or_title">
                <span class="title">{{ title }}</span>
            </div>
            <div class="check_box">
                <div class="form-wrap">
                    <el-form :inline="true" class="demo-form-inline secondLevel-form-inline">
                        <el-row>
                            <el-form-item label="起止时间">
                                <DatePicker :init-width="'630px'" :formatType="'YYYY-MM-DD HH:mm:ss'" dateType="timerange" :currentDateList="dateArr" :needInitTime="false" :topPx="'50px'" :leftPx="'-200px'" @dateChange="changeTime">
                                </DatePicker>
                            </el-form-item>
                            <el-form-item label="分厂/所属区域">
                                <el-select v-model="branchFactoryId" filterable placeholder="请选择">
                                    <el-option v-for="item in branchFactoryList" :key="item.nameType" :label="item.name" :value="item.nameType">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="生产工艺线">
                                <el-select v-model="processId" filterable placeholder="请选择">
                                    <el-option v-for="item in processList" :key="'process-' + item.id" :label="item.process" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-row>
                        <el-row>
                            <el-form-item label="设备类别">
                                <el-select v-model="deviceClass" @change="devicePrimaryTypeChange" placeholder="请选择">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="item in devicePrimaryTypeList" :key="item.primaryTypeName" :label="item.primaryTypeName" :value="item.primaryTypeId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="设备类型">
                                <el-select v-model="deviceType" placeholder="请选择">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="item in deviceTypeList" :key="item.typeName" :label="item.typeName" :value="item.typeId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="设备名称">
                                <el-input v-model="deviceName" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="处理结果">
                                <el-select v-model="handleStatus" placeholder="请选择">
                                    <el-option label="全部" value="0"></el-option>
                                    <el-option v-for="item in resultList" :key="item.key" :label="item.value" :value="item.key">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-row>
                        <el-row>
                            <!-- <div class="left_f">
                                
                            </div> -->
                            <!-- <el-form-item label="事件类别" v-if="title == '日常巡检' || title == '维护事件' || title == '诊断详情'">
                                <el-select v-model="deviceType" placeholder="请选择">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="item in branchFactoryList" :key="item.nameType" :label="item.name" :value="item.nameType">
                                    </el-option>
                                </el-select>
                            </el-form-item> -->
                            <el-form-item label="问题细分" v-if="title == '问题处理'">
                                <el-select v-model="ticketType" placeholder="请选择">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="item in ticketTypeList" :key="item.key" :label="item.name" :value="item.key">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="保养类型" v-if="title == '保养校准'">
                                <el-select v-model="ticketType" placeholder="请选择">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="item in ticketTypeList" :key="item.key" :label="item.name" :value="item.key">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="事件类型" v-if="title == '维护事件' || title == '诊断详情'">
                                <el-select v-model="ticketType" placeholder="请选择">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="item in eventTypeList" :key="item.key" :label="item.value" :value="item.key">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <div style="width: 520px"></div>
                            <div class="btn-group">
                                <a class="self_btn" @click="getSearchBtn()">查询</a>
                                <a class="self_btn" @click="getReset()">重置</a>
                                <a class="self_btn" v-if="title == '诊断详情'" @click="exportData()">导出</a>
                            </div>
                        </el-row>

                    </el-form>
                </div>
                <!-- <div class="value HuXiaoBo" v-if="title == '保养校准' || title == '问题处理' || title == '日常巡检'">
                    <div class="img_val">
                        <img :src="bgImg" :style="{'width':imgW, 'height': imgH}" alt="">
                        <div :style="{'left':valW, 'top': valH}" class="val_unit"><span>{{ value }}</span> <span class="unit">总计</span>
                        </div>
                    </div>
                    <div class="line"></div>
                    <div class="search_value">查到： <span>{{ page_total }}</span> </div>
                </div> -->
                <!-- v-if="title == '维护事件' || title == '诊断详情'" -->
                <div class="value HuXiaoBo" :style="{'top': top}" > 
                    <div class="img_val">
                        <img :src="bgImg" :style="{'width':imgW, 'height': imgH}" alt="">
                        <div :style="{'left':valW, 'top': valH}" class="val_unit"><span>{{ page_total }}</span> <span class="unit">总计</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table_box">
                <el-table :data="tableData" v-loading="tableLoading" :empty-text="tableLoading?' ':'暂无数据'" element-loading-background="rgba(255, 255, 0, .0)" element-loading-text="加载中，请稍后..." stripe style="width: 100%" height="100%">
                    <el-table-column type="index" label="序号" width="100" align="center" />
                    <el-table-column v-for="(item, index) in headerList" :prop="item.prop" :key="index" :label="item.label" :width="item.width" align="center">
                    </el-table-column>
                    <!-- <el-table-column prop="equipmentName" label="设备名称" align="center">
                    </el-table-column>
                    <el-table-column prop="equipmentCode" label="设备编码" align="center">
                    </el-table-column>
                    <el-table-column prop="supportType" label="保障类型" align="center">
                    </el-table-column>
                    <el-table-column prop="result" label="处理结果" align="center">
                    </el-table-column> -->

                </el-table>
            </div>
            <div class="page_box">
                <el-pagination @current-change="handleCurrentChange" background :current-page="paramsList.pageNo" :page-size="paramsList.pageSize" layout="total,prev, pager, next, jumper" :total="page_total" :pager-count="5"></el-pagination>
            </div>
        </div>
    </div>
</template>
 
 <script>
import jsonData from '/public/static/js/json/operatieCenter.json';
import { dateFormat } from "utils/tools";
import axios from "axios";
import { DatePicker } from "@/modules/commonDatePicker";
export default {
    name: 'dialog',
    components: { DatePicker },
    data () {
        return {
            title: '设备在线率',
            value: '',
            bgImg: require('./img/5.png'),
            imgW: '188px',
            imgH: '194px',
            top: "-80px",
            isChoose: true,
            page_total: 0,
            showData: [],
            tableLoading: false,
            tableData: [],
            deviceTypeArr: [],
            paramsList: {
                startTime: dateFormat(
                    "YYYY-mm-dd HH:MM:SS",
                    new Date(new Date() - 24 * 60 * 60 * 1000)
                ),
                endTime: dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
                pageNo: 1,
                pageSize: 20,
            },
            dateArr: [
                new Date(new Date() - 30 * 24 * 60 * 60 * 1000),
                new Date(),
            ],

            branchFactoryList: [],
            processList: [],
            sectionList: [],
            deviceTypeList: [],
            devicePrimaryTypeList: [],
            resultList: [],
            eventTypeList: [],
            ticketTypeList: [],
            // 参数
            branchFactoryId: '',
            processId: '',
            deviceClass: '',
            deviceType: '',
            deviceName: '',
            ticketType: '',
            taskStatus: '',
            handleStatus: '0',
            headerList: [
                { label: '日期', prop: 'equipmentName', width: 400 },
                { label: '分厂/所属区域', prop: 'equipmentCode', width: 300 },
                { label: '生产工艺线', prop: 'supportType', width: '' },
                { label: '设备类别', prop: 'equipmentName', width: '' },
                { label: '设备类型', prop: 'equipmentCode', width: '' },
                { label: '设备名称', prop: 'supportType', width: '' },
                { label: '设备编码', prop: 'equipmentName', width: '' },
                { label: '设备在线率', prop: 'supportType', width: '' },
            ]
        }
    },
    computed: {
        dialogValue () {
            return this.$store.state.operationCenterDialog
        }
    },
    watch: {
        branchFactoryId: {
            handler (newVal, oldVal) {
                this.processId = "";
                this.getProcessListResult();
            },
            deep: true,
        },
        dialogValue: {
            handler (newVal, oldVal) {
                console.log("dialogValue", newVal)
                this.title = newVal.params.type
                if (this.title == '维护事件') {
                    if (newVal.params.value == 999) {
                        this.dateArr[0] = new Date(new Date().setHours(0, 0, 0, 0))
                    } else {
                        this.taskStatus = '6'
                        this.handleStatus = '3'
                    }
                    
                    
                    this.value = newVal.params.value
                    this.bgImg = require('./img/1.png')
                    this.imgW = '160px'
                    this.imgH = '160px'
                    this.top = "-30px"
                    this.headerList = [
                        { label: '创建时间', prop: 'createTime', width: 300 },
                        { label: '分厂/所属区域', prop: 'branchFactoryName', width: 200 },
                        { label: '生产工艺线', prop: 'productLine', width: '' },
                        { label: '事件类别', prop: 'ticketTypeName', width: '' },
                        { label: '设备类别', prop: 'primaryTypeName', width: '' },
                        { label: '设备类型', prop: 'typeName', width: '' },
                        { label: '设备名称', prop: 'deviceName', width: '' },
                        { label: '设备编码', prop: 'deviceNo', width: '' },
                        { label: '问题描述', prop: 'description', width: 500 },
                        { label: '处理结果', prop: 'taskStatusDesc', width: '' },
                    ]
                } else if (this.title == '问题处理') {
                    this.taskStatus = '6'
                    this.handleStatus = '3'
                    this.value = newVal.params.value
                    this.bgImg = require('./img/7.png')
                    this.imgW = '160px'
                    this.imgH = '160px'
                    this.top = "-30px"
                    this.headerList = [
                        { label: '创建时间', prop: 'createTime', width: 300 },
                        { label: '分厂/所属区域', prop: 'branchFactoryName', width: 200 },
                        { label: '生产工艺线', prop: 'productLine', width: '' },
                        { label: '问题细分', prop: 'ticketTypeName', width: '' },
                        { label: '设备类别', prop: 'primaryTypeName', width: '' },
                        { label: '设备类型', prop: 'typeName', width: '' },
                        { label: '设备名称', prop: 'deviceName', width: '' },
                        { label: '设备编码', prop: 'deviceNo', width: '' },
                        { label: '问题描述', prop: 'description', width: 500 },
                        { label: '处理结果', prop: 'taskStatusDesc', width: '' },
                    ]
                } else if (this.title == '日常巡检') {
                    this.taskStatus = '6'
                    this.handleStatus = '3'
                    this.value = newVal.params.value
                    this.bgImg = require('./img/4.png')
                    this.imgW = '160px'
                    this.imgH = '160px'
                    this.top = "-30px"
                    this.headerList = [
                        { label: '创建时间', prop: 'createTime', width: 300 },
                        { label: '分厂/所属区域', prop: 'branchFactoryName', width: 200 },
                        { label: '生产工艺线', prop: 'productLine', width: '' },
                        { label: '保养类型', prop: 'ticketTypeName', width: '' },
                        { label: '设备类别', prop: 'primaryTypeName', width: '' },
                        { label: '设备类型', prop: 'typeName', width: '' },
                        { label: '设备名称', prop: 'deviceName', width: '' },
                        { label: '设备编码', prop: 'deviceNo', width: '' },
                        { label: '问题描述', prop: 'description', width: '' },
                        { label: '处理结果', prop: 'taskStatusDesc', width: '' },
                    ]
                } else if (this.title == '保养校准') {
                    this.taskStatus = '6'
                    this.handleStatus = '3'
                    this.value = newVal.params.value
                    this.bgImg = require('./img/6.png')
                    this.imgW = '160px'
                    this.imgH = '160px'
                    this.top = "-30px"
                    this.headerList = [
                        { label: '创建时间', prop: 'createTime', width: 300 },
                        { label: '分厂/所属区域', prop: 'branchFactoryName', width: 200 },
                        { label: '生产工艺线', prop: 'productLine', width: '' },
                        { label: '事件类型', prop: 'ticketTypeName', width: '' },
                        { label: '设备类别', prop: 'primaryTypeName', width: '' },
                        { label: '设备类型', prop: 'typeName', width: '' },
                        { label: '设备名称', prop: 'deviceName', width: '' },
                        { label: '设备编码', prop: 'deviceNo', width: '' },
                        { label: '问题描述', prop: 'description', width: 500 },
                        { label: '处理结果', prop: 'taskStatusDesc', width: '' },
                    ]
                } else if (this.title == '诊断详情') {
                    console.log("1234", newVal.params.value, new Date(new Date(newVal.params.value).getTime() - 2 * 60 * 60 * 1000))
                    
                    this.dateArr[1] = new Date(new Date(newVal.params.value).getTime())
                    this.dateArr[0] = new Date(new Date(newVal.params.value).getTime() - 2 * 60 * 60 * 1000)
                    this.value = newVal.params.value
                    this.bgImg = require('./img/8.png')
                    this.imgW = '160px'
                    this.imgH = '160px'
                    this.top = "-30px"
                    this.headerList = [
                        { label: '创建时间', prop: 'createTime', width: 300 },
                        { label: '分厂/所属区域', prop: 'branchFactoryName', width: 200 },
                        { label: '生产工艺线', prop: 'productLine', width: '' },
                        { label: '事件类型', prop: 'ticketTypeName', width: '' },
                        { label: '设备类别', prop: 'primaryTypeName', width: '' },
                        { label: '设备类型', prop: 'typeName', width: '' },
                        { label: '设备名称', prop: 'deviceName', width: '' },
                        { label: '设备编码', prop: 'deviceNo', width: '' },
                        { label: '问题描述', prop: 'description', width: 500 },
                        { label: '处理结果', prop: 'taskStatusDesc', width: '' },
                    ]
                }

            },
            deep: true,
            immediate: true
        }
    },
    created () {
        this.getTableData();
        this.initDate()
        this.getTypeListByCustomerId()
        this.getPrimaryTypeByCustomerId()
        this.getDictList(15)
        this.getDictList(17)
        if (this.title == '问题处理') {
            this.getTicketType(3)
        } else if (this.title == '保养校准') {
            this.getTicketType(2)
        } else if (this.title == '日常问题') {
            this.getTicketType(1)
        }
    },
    mounted () {
    },
    methods: {
        async initDate () {
            this.branchFactoryList = await this.getFactoryArea();
            this.processList = await this.getProcessList();
            this.sectionList = await this.getSectionList();
        },
        async getSectionList () {
            let that = this;
            return new Promise(function (resolve, reject) {
                if (that.branchFactoryId && that.processId) {
                    let findProcessSectionUrl =
                        CONFIG.requestName + that.$apiOpt.findProcessSection;
                    that.$apiUtils
                        .get(findProcessSectionUrl, {
                            customerId: that.$store.state.customerId,
                            nameType: that.branchFactoryId,
                            process: that.processId,
                            type: "",
                        })
                        .then(function (data) {
                            let list = [];
                            data &&
                                data.forEach((item) => {
                                    if (item) {
                                        list.push(item);
                                    }
                                });
                            let areaAll = [
                                {
                                    id: "",
                                    processSection: "全部",
                                },
                            ];
                            $.merge(areaAll, list);
                            that.sectionId = "";
                            resolve(areaAll);
                        });
                } else {
                    let areaAll = [
                        {
                            id: "",
                            processSection: "全部",
                        },
                    ];
                    that.sectionId = "";
                    resolve(areaAll);
                }
            });
        },
        async getProcessList () {
            let that = this;
            return new Promise(function (resolve, reject) {
                if (that.branchFactoryId) {
                    let findProcessUrl = CONFIG.requestName + that.$apiOpt.findProcess;
                    that.$apiUtils
                        .get(findProcessUrl, {
                            customerId: that.$store.state.customerId,
                            nameType: that.branchFactoryId,
                            type: "",
                        })
                        .then(function (data) {
                            let list = [];
                            data.forEach((item) => {
                                if (item) {
                                    list.push(item);
                                }
                            });
                            let areaAll = [
                                {
                                    id: "",
                                    process: "全部",
                                },
                            ];
                            $.merge(areaAll, list);
                            that.processId = "";
                            resolve(areaAll);
                            //that.processList = areaAll;
                        });
                } else {
                    let areaAll = [
                        {
                            id: "",
                            process: "全部",
                        },
                    ];
                    that.processId = "";
                    resolve(areaAll);
                }
            });
        },
        async getFactoryArea () {
            let that = this;
            return new Promise(function (resolve, reject) {
                let findInventorySelectTwoUrl =
                    CONFIG.requestName + that.$apiOpt.findInventorySelectTwo;
                that.$apiUtils
                    .get(findInventorySelectTwoUrl, {
                        customerId: that.$store.state.customerId,
                        type: "",
                    })
                    .then(function (data) {
                        let list = [];
                        data.forEach((item) => {
                            if (item) {
                                list.push(item);
                            }
                        });
                        let areaAll = [
                            {
                                nameType: "",
                                name: "全厂",
                            },
                        ];
                        $.merge(areaAll, list);
                        resolve(areaAll);
                    });
            });
        },
        async getProcessListResult () {
            this.processList = await this.getProcessList();
            console.log(this.processList);
            this.$forceUpdate();
        },
        async getTableData () {
            let that = this
            this.tableLoading = true
            let title = this.title
            let params = { ...this.paramsList }
            let url = ''
            params.startTime = Date.parse(this.dateArr[0])
            params.endTime = Date.parse(this.dateArr[1])
            params.customerId = that.$store.state.customerId
            params.branchFactoryId = that.branchFactoryId
            params.productLineId = that.processId
            params.primaryTypeId = that.deviceClass
            params.typeId = that.deviceType
            params.deviceName = that.deviceName
            params.ticketType = that.ticketType // 工单类型
            // params.taskStatus = that.taskStatus // 任务状态
            params.handleStatus = that.handleStatus // 处理结果
            if (title == '问题处理') {
                url = CONFIG.requestName + this.$apiOpt.getRelationList;
                params.type = 3
            } else if (title == '保养校准') {
                url = CONFIG.requestName + this.$apiOpt.getRelationList;
                params.type = 2
            } else if (title == '日常巡检') {
                url = CONFIG.requestName + this.$apiOpt.getRelationList;
                params.type = 1
            } else if (title == '诊断详情') {
                url = CONFIG.requestName + this.$apiOpt.checkTaskList;
                params.taskResource = 5
                
            } else if (title == '维护事件') {
                url = CONFIG.requestName + this.$apiOpt.getRelationList;
                params.type = ''
            }
            try {
                this.$apiUtils
                .get(url, params)
                .then(data => {
                    that.tableLoading = false
                    that.tableData = data.records || []
                    that.page_total = data.total || 0
                });
            } catch (err) {
                that.tableLoading = false
            }
            
        },
        // 获取设备类型
        getTypeListByCustomerId () {
            let url = CONFIG.requestName + this.$apiOpt.getTypeListByCustomerId;
            let params = {
                customerId: this.$store.state.customerId
            }
            this.$apiUtils
                .get(url, params)
                .then(data => {
                    this.deviceTypeArr = data
                });
        },
        // 获取设备类别
        getPrimaryTypeByCustomerId () {
            let url = CONFIG.requestName + this.$apiOpt.getPrimaryTypeByCustomerId;
            let params = {
                customerId: this.$store.state.customerId
            }
            this.$apiUtils
                .get(url, params)
                .then(data => {
                    this.devicePrimaryTypeList = data
                });
        },
        devicePrimaryTypeChange(val) {
            console.log('val', val)
            let arr = []
            for (let item of this.deviceTypeArr) {
                if (item.primaryTypeId == val) {
                    arr.push(item)
                }
            }
            
            this.deviceTypeList = arr
        },
        // 任务类型下拉
        getTicketType (type) {
            let that = this
            let url = CONFIG.requestName + this.$apiOpt.getTicketType;
            let params = {
                type
            }
            this.$apiUtils
                .get(url, params)
                .then(data => {
                    that.ticketTypeList = data
                });
        },
        // 字典接口
        getDictList (typeId) {
            let url = CONFIG.requestName + this.$apiOpt.getDictList;
            let params = {
                typeId
            }
            this.$apiUtils
                .get(url, params)
                .then(data => {
                    if (typeId == 17) {
                        this.eventTypeList = data
                    } else if (typeId == 15) {
                        this.resultList = data
                        this.resultList = [
                            {   
                                key: '1',
                                value: '未解决'
                            },{
                                key: "2", 
                                value: "解决中"
                            },{
                                key: "3", 
                                value: "已解决"
                            }
                        ]
                    }

                });
        },

        exportFun () {
            this.$message.info('正在导出数据……')
            let ip = bmeConfig.baseUrl + '/' + CONFIG.requestName
            let str = `${ip}/customer/self/check/task/export?startTime=${Date.parse(this.dateArr[0])}&endTime=${Date.parse(this.dateArr[1])}&branchFactoryId=${this.branchFactoryId}&taskResource=5&&customerId=${this.$store.state.customerId}&taskStatus=${this.taskStatus}&ticketType=${this.ticketType}&deviceName=${this.deviceName}&typeId=${this.deviceType}&primaryTypeId=${this.deviceClass}&productLineId=${this.processId}&handleStatus=${this.handleStatus}`
            let a = document.createElement('a')
            a.setAttribute('href', str)
            a.setAttribute('id', 'startTelMedicine')
            // a.setAttribute('download', `${'诊断详情'}.xlsx`)
            a.download = `${'诊断详情'}.xlsx`
            document.body.appendChild(a)
            a.click()
            let elem = document.getElementById('startTelMedicine')
            elem.parentNode.removeChild(elem)
        },

        exportData () {
            let that = this
            let ip = bmeConfig.baseUrl + '/' + CONFIG.requestName
            let params = {}
            params.startTime = Date.parse(this.dateArr[0])
            params.endTime = Date.parse(this.dateArr[1])
            params.customerId = that.$store.state.customerId
            // params.branchFactoryId = that.branchFactoryId
            // params.productLineId = that.processId
            // params.primaryTypeId = that.deviceClass
            // params.typeId = that.deviceType
            params.taskResource = 5
            // params.deviceName = that.deviceName
            // params.ticketType = that.ticketType // 工单类型
            // params.taskStatus = that.taskStatus // 任务状态
            let url = ip + '/customer/self/check/task/export'
            axios
                .get(url, {
                    responseType: "blob",
                    params: params,
                    headers: {}
                })
                .then((res) => {
                    console.log(res, '<========');
                    if (res.data) {
                        const BLOB = res.data; // Blob 对象表示一个不可变、原始数据的类文件对象（File 接口都是基于Blob）
                        const fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
                        fileReader.readAsDataURL(BLOB); // 开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
                        fileReader.onload = (event) => {
                            // 处理load事件。该事件在读取操作完成时触发
                            // 新建个下载的a标签，完成后移除。
                            let a = document.createElement("a");
                            a.download = `${'诊断详情'}.xlsx`;
                            a.href = event.target.result;
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        };
                        fileReader.onloadend = () => {
                            try {
                                const jsonData = JSON.parse(fileReader.result)
                                console.log('jsonData', jsonData)
                            } catch (err) {
                                console.log('jsonData err', err)
                            }
                        }
                    }
                    
                });
        },
        handleCurrentChange (val) {
            this.paramsList.pageNo = val;
            this.getTableData();
        },

        getSearchBtn () {
            this.getTableData();
        },

        getReset () {
            this.branchFactoryId = ''
            this.processId = ''
            this.deviceClass = ''
            this.deviceType = ''
            this.deviceName = ''
            this.ticketType = ''
            this.taskStatus = ''
            this.handleStatus = '0'
            this.dateArr = [
                new Date(new Date() - 30 * 24 * 60 * 60 * 1000),
                new Date(),
            ]
            this.getTableData();
        },

        changeTime (date) {
            console.log('date', date)
            this.dateArr = date
        },

        close () {
            this.$store.commit("upDateOperationCenterDialog", { state: false, params: '' });
        }
    }
}
 </script>
 
 <style lang="scss" scoped>
.diolog_style {
    transition: none 0s ease 0s;
    height: 100%;
    border: 2px solid;
    display: flex;
    flex-direction: column;
    border-image: linear-gradient(
            180deg,
            rgba(0, 201.00000321865082, 255, 1),
            rgba(177.88819938898087, 253.6357820034027, 252.12083369493484, 1)
        )
        2 2;
    .main_style {
        flex: 1;
        margin: 12px 18px;
        padding: 0 50px;
        box-shadow: inset 0px 0px 5px 0px rgba(0, 0, 0, 0.4632);
        background: rgba($color: #021b42, $alpha: 0.7);
        display: flex;
        flex-direction: column;
        height: calc(100% - 24px);
        box-sizing: border-box;
        .btn-group {
            margin-right: 70px;
        }
    }
    .or_title {
        font-size: 30px;
        font-family: Source Han Sans CN-Bold, Source Han Sans CN;
        font-weight: 700;
        color: #63f2ef;
        line-height: 36px;
        width: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
        margin-top: 26px;
    }
    .check_box {
        display: flex;
        align-items: center;
        margin-top: 30px;
        padding-right: 200px;
        position: relative;
        .form_select_style {
            margin-right: 20px;
            span {
                margin-right: 10px;
            }
        }
        .left_f {
            display: flex;
        }
        .value {
            text-align: center;
            // background: url("./img/tabItem.png") no-repeat center center;
            font-size: 45px;
            font-weight: 400;

            text-shadow: 4px 4px 20px #092f78;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background-size: cover;
            position: absolute;
            right: 90px;
            top: -80px;
            .img_val {
                display: flex;
                align-items: center;
            }
            img {
                height: 162px;
                width: 210px;
            }
            .val_unit {
                // position: absolute;
                // top: 50%;
                // left: 50%;
                // transform: translate(-50%, -50%);
                display: flex;
                flex-direction: column;
                align-items: center;
                color: #32c5ff;
                margin-left: 20px;
            }
            .unit {
                font-size: 32px;
                // padding-top: 20px;
                // padding-left: 2px;
                color: rgba(255, 255, 255, 0.75);
                line-height: 40px;
                text-shadow: 4px 4px 20px #092f78;
            }
            .line {
                width: 408px;
                height: 4px;
                margin: 22px 0 13px 0;
                background: linear-gradient(
                    297deg,
                    rgba(0, 238, 255, 0) 0%,
                    #2d7aff 49%,
                    rgba(0, 238, 255, 0) 100%
                );
                border-radius: 0px 0px 0px 0px;
            }
            .search_value {
                display: flex;
                align-items: center;
                color: rgba(255, 255, 255, 0.75);
                line-height: 38px;
                text-shadow: 4px 4px 20px #092f78;
                font-size: 32px;
                span {
                    color: #f4de52;
                    font-size: 34px;
                    line-height: 38px;
                    text-shadow: 4px 4px 20px #092f78;
                }
            }
        }
    }
    .isBaoSteel {
        background: #020f3f;
    }
    .box_wrap {
        height: 100%;
    }
    .or_title {
        display: flex;
        .show_more {
            margin-left: auto;
            font-size: 20px;
            margin-right: 10px;
        }
    }
    .table_box {
        background: transparent;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        margin-top: 0px;
        flex: 1;
        .el-table {
            background: transparent;
        }
        :deep(.el-table) {
            th > .cell {
                color: #49d9d2 !important;
                font-size: 20px;
            }

            tbody {
                .cell {
                    color: #c6d6df;
                }
                .el-table__row {
                    background: linear-gradient(
                        180deg,
                        rgba(108, 151, 255, 0.2) 0%,
                        rgba(107, 151, 255, 0.1988) 48%,
                        rgba(58, 116, 255, 0.1) 100%,
                        rgba($color: #0049fa, $alpha: 0.7) 100%,
                        rgba($color: #0049fa, $alpha: 0.7) 100%
                    );
                    // border: 1px solid #8BADFF;
                    td {
                        border-bottom: 1px solid #8badff;
                    }
                }

                .el-table__row--striped {
                    background: linear-gradient(
                        180deg,
                        rgba(108, 151, 255, 0.2) 0%,
                        rgba(107, 151, 255, 0.1988) 48%,
                        rgba(58, 116, 255, 0.1) 100%,
                        #0049fa 100%,
                        #0049fa 100%
                    ) !important;
                    td {
                        border-bottom: 1px solid #8badff;
                    }
                }
            }
        }
        :deep(.el-table__header) {
            width: auto !important;
            .has-gutter {
                height: 50px;
                background: transparent;
                // filter: blur(38.08000183105469px);
                border: 1px solid #84aaff;
                tr th {
                    background: linear-gradient(
                        180deg,
                        rgba(108, 151, 255, 0.2) 0%,
                        rgba(107, 151, 255, 0.1988) 48%,
                        rgba(58, 116, 255, 0.1) 100%,
                        #0049fa 100%,
                        #0049fa 100%
                    );
                    border-bottom: 1px solid #8badff;
                }
            }
        }
        :deep(.el-table th > .cell) {
            white-space: initial;
            overflow: initial;
            font-size: 24px;
            color: #47ffdd !important;
        }
        :deep(.el-table__body) {
            width: auto !important;
        }
        :deep(.el-table__body-wrapper) {
            overflow-x: hidden;
            .el-table__empty-block {
                width: auto !important;
            }
        }
    }
    .page_box {
        width: 100%;
        margin-top: 10px;
        padding-bottom: 10px;
        :deep(.el-pager) {
            li {
                background-color: transparent !important;
            }
        }
        :deep(.el-pagination) {
            padding-right: 50px !important;
            font-size: 29px !important;
            button {
                height: 28px !important;
                line-height: 28px !important;
                width: 10px;
            }
            li {
                height: 28px !important;
                line-height: 28px !important;
                width: 40px !important;
                font-size: 22px !important;
                color: #fff;
            }
            li:not(.disabled).active {
                color: #32c5ff;
            }
            .btn-prev {
                background: none !important ;
                color: white !important;
            }

            .btn-next {
                background: none !important;
                color: white !important;
            }
            .el-pagination__total {
                font-size: 22px !important;
            }
            .el-pagination__jump {
                font-size: 22px !important;
            }
        }
    }
}
</style>

<style lang="scss">
.diolog_style {
    .device_statistic {
        .el-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }
    .el-form--inline .el-form-item {
        margin: 0;
        display: flex;
        align-items: center;
        margin-right: 70px;
    }

    .check_box {
        .el-row {
            margin-bottom: 16px;
        }
        .el-select {
            height: 40px;
        }
        .el-form-item .el-form-item__label {
            padding-right: 20px;
            font-weight: 400;
            color: #32c5ff;
            font-size: 24px;
            // width: 200px;
        }
        .date-picker-editor_dark {
            // background: rgba($color: #021B42, $alpha: 0.7);
            border: 1px solid #32c5ff;
            background: rgba(0, 0, 0, 0.1) !important;
            box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.302);
            border-radius: 6px 6px 6px 6px;
            font-size: 20px;
            span {
                color: #fff !important;
            }
        }
        .date-picker-wrap .date-eidtor .date-edit-input {
            font-size: 22px;
        }
        .date-picker-editor_dark > i {
            color: #fff !important;
        }
        .el-input .el-input__inner {
            background: rgba(0, 0, 0, 0.2002);
            border-radius: 6px 6px 6px 6px;
            opacity: 1;
            border: 1px solid #32c5ff;
            height: 40px;
            color: #fff;
            width: 200px;
            font-size: 22px;
        }
        .date-bottom .select-trigger .el-input .el-input__inner {
            border: inherit;
            height: inherit;
            color: inherit;
            width: inherit;
        }
        .el-select .select-trigger .el-input .el-input__inner {
            background: rgba(0, 0, 0, 0.2002);
            border-radius: 6px 6px 6px 6px;
            opacity: 1;
            border: 1px solid #32c5ff;
            height: 40px;
            color: #fff;
        }
        .diolog_style .table_box .el-table th > .cell {
            font-size: 22px !important;
        }
    }

    .page_box .el-pagination__editor .el-input__inner {
        font-size: 20px;
        height: 32px;
        background: rgba(0, 0, 0, 0.2002);
        border-radius: 6px 6px 6px 6px;
        opacity: 1;
        border: 1px solid #32c5ff;
    }
}
</style>
 